// 计算y轴显示长度
import store from '@/store'
export function computedYLegnth(total) {
    if (total < 10) {
        return 100
    } else {
        return (10 / total) * 100
    }

}
// 日期返回
// 2.获取时间段内的所有日期 Spacer:间隔符
// 1.处理日期格式
function getDate(datestr) {
    let temp = datestr.split("-");
    let date = new Date(temp[0], temp[1] - 1, temp[2]);
    return date;
}
export function timestamp(time) {
    if ((time + "").length == 10) {
        time = time * 1000;
    }
    var date = new Date(time);
    var Y = date.getFullYear() + "-";
    var M =
        (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + "-";
    var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var strDate = Y + M + D;
    return strDate;
}
export function formatEveryDay(start, end) {
    let dateList = [];
    let startTime = getDate(start);
    let endTime = getDate(end);

    while (endTime.getTime() - startTime.getTime() >= 0) {
        let year = startTime.getFullYear();
        let month =
            startTime.getMonth() + 1 < 10 ?
                "0" + (startTime.getMonth() + 1) :
                startTime.getMonth() + 1;
        let day =
            startTime.getDate().toString().length == 1 ?
                "0" + startTime.getDate() :
                startTime.getDate();
        dateList.push(year + "/" + month + "/" + day);

        startTime.setDate(startTime.getDate() + 1);
    }
    // console.log("dateList", this.dateList);
    return dateList;
}

// 修改显示类型
export function changeShowType(params, newValue) {
    console.log(7777788, params, newValue);
    let showType = newValue[0]
    console.log(showType, "showType");
    let list = store.getters.machineList
    let showList = []
    params.forEach(item => {
        switch (showType) {
            case 0:
                break;
            case 1:
                showList.push(list.get(item).name)
                break;
            case 2:
                showList.push(list.get(item).pdescribe)
                break;
            default:
                break;
        }

    });
    return showList
}

export function addMachineName(params) {
    let list = store.getters.machineList
    return list.get(params)

}
export function singletype(params, newValue) {
    let showType = newValue[0]
    let list = store.getters.machineList
    let name = null
    switch (showType) {
        case 0:
            name = params
            break;
        case 1:
            name = (list.get(params).name)
            break;
        case 2:
            name = (list.get(params).pdescribe)
            break;
        default:
            break;
    }
    return name
}